import { useContext } from "react";
import EdenWebContext from '../contexts/index';

function useWebContext(){
    return useContext(EdenWebContext);
}

export default useWebContext;